import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { advisorGate } from '@/lib/advisorGate';

export function RequireAdvisor({ children }: { children: ReactNode }) {
  const { isReady, token, role } = useAuth();
  const gate = advisorGate({ isReady, token, role });
  if (gate === 'loading') return null;
  if (gate === 'signin') return <Navigate to="/sign-in" replace />;
  if (gate === 'notauthorised') return <Navigate to="/not-authorised" replace />;
  return <>{children}</>;
}
